import React from 'react';
import LocationTemplate from './LocationTemplate';

const PikevillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Pikeville"
      stateName="North Carolina"
      countyName="Wayne"
      zipCodes={["27863"]}
      latitude={35.496}
      longitude={-77.9881}
      population={678}
      historicalFact="Incorporated in 1891, named after a local family or potentially Pike County, Georgia."
      nearbyTowns={[
        "Goldsboro, NC",
        "Mount Olive, NC",
        "Fremont, NC",
        "Seven Springs, NC",
        "Eureka, NC",
        "LaGrange, NC",
        "Kinston, NC",
        "Dudley, NC"
      ]}
    />
  );
};

export default PikevillePage;